import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllWorkerTypeService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allWorkerTypeService = useQuery({
    queryKey: [...CACHE_KEYS.WORK_TYPES, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.WORK_TYPES,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allWorkerTypeService },
    states: { searchQuery, setSearchQuery },
  };
};
